import { render } from "./Project.vue?vue&type=template&id=11c97fac"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"
script.render = render

export default script